import { Pipe, PipeTransform } from '@angular/core';
import { formatBalanceMoney } from 'shared/utils/balance-format.utils';

@Pipe({ name: 'balanceMoney', standalone: true })
export class BalanceMoneyPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    return formatBalanceMoney(value);
  }
}
